import { c as _c } from "react/compiler-runtime";
import { PortableText } from "next-sanity";
import { getInlineRichTextVariant, type InlineRichTextVariant } from "./InlineRichText.registry";
import type { InlineRichTextValue } from "./isRichTextValue";
type InlineRichTextProps = {
  content: InlineRichTextValue;
  variant?: InlineRichTextVariant;
};

/**
 * Renders short formatted text (paragraphs, emphasis, links) with no embedded blocks.
 * One of two places allowed to know the rich text format; the other is `components/portable`.
 */
export function InlineRichText(t0) {
  const $ = _c(5);
  const {
    content,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "accessible" : t1;
  let t2;
  if ($[0] !== variant) {
    t2 = getInlineRichTextVariant(variant);
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content || $[3] !== t2) {
    t3 = <PortableText value={content} components={t2} />;
    $[2] = content;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}